import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileStorageService } from '../../services/file-storage.service';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent implements OnChanges {
  /** Full name to generate initials from. */
  @Input() name = '';
  /** UUID from Wasabi file storage. If set, loads the photo. */
  @Input() photoUuid: string | null = null;
  /** Size in px. */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  initials = '';
  bgColor = '';
  photoUrl: string | null = null;
  loading = false;

  private sizes = { sm: 32, md: 40, lg: 80 };

  get px() { return this.sizes[this.size]; }

  constructor(private fileSrv: FileStorageService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['name']) {
      this.initials = this.getInitials(this.name);
      this.bgColor = this.generateColor(this.name);
    }
    if (changes['photoUuid']) {
      this.photoUrl = null;
      if (this.photoUuid) this.loadPhoto(this.photoUuid);
    }
  }

  private loadPhoto(uuid: string) {
    this.loading = true;
    this.fileSrv.getDownloadUrl(uuid).subscribe({
      next: (resp) => { this.photoUrl = resp.url; this.loading = false; },
      error: () => { this.photoUrl = null; this.loading = false; }
    });
  }

  private getInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  private generateColor(name: string): string {
    const colors = [
      '#4657ec', '#11b7ee', '#ffd500', '#57aa8a', '#f06292',
      '#7c4dff', '#ff7043', '#26a69a', '#5c6bc0', '#ef5350'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
  }
}
